import React, { useState, useEffect } from 'react';
import { MapPin, Layers, Box, ExternalLink, Database, AlertCircle, Loader2 } from 'lucide-react';

import './poitable.css'
import config from './config';
import MHeader from './header';
import Mfooter from './footer';
import { get } from 'ol/proj';

// --- MOCK API ---
// In produzione, sostituisci questo blocco con la chiamata fetch reale

const PoiTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
         const response = await fetch(config.apiUrl+'/getpoi');
         const result = await response.json();
   
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  if (loading) {
    return (
      <div className="poi-message">
        <Loader2 className="poi-header-icon" style={{ animation: 'spin 1s linear infinite' }} />
        <p>Caricamento dati POI...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="poi-error">
        <AlertCircle size={24} />
        <p>Errore: {error}</p>
      </div>
    );
  }



  return (
    <div className="poi-container">
        <MHeader/>
      <div className="poi-wrapper">
        
        <header className="poi-header">
          <div>
            <br/>
            <br/>
            <br/>
            <Database className="poi-header-icon" />
            <h1 className="poi-title">Elenco dati presenti </h1>
          </div>
        </header>

        <div className="poi-card">
          <div className="poi-table-responsive">
            <table className="poi-table">
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>ID</th>
                  <th style={{ width: '25%' }}>Luogo & Descrizione</th>
                  <th>Posizione</th>
                  <th>Layers GIS</th>
                  <th>Caratteristiche 
                    con allegati e misurazioni</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id_luogo}>
                    
                    {/* ID */}
                    <td className="poi-id">#{item.id_luogo}</td>

                    {/* Nome e Descrizione */}
                    <td>
                      <div className="poi-name">{item.nome}</div>
                      <div className="poi-desc" title={item.ldescrizione}>
                        {item.ldescrizione}
                      </div>
                    </td>

                    {/* Indirizzo e Coordinate */}
                    <td>
                      <div className="poi-address">
                        <MapPin size={16} color="#ef4444" style={{ marginTop: '2px' }} />
                        <span>{item.indirizzo}</span>
                      </div>
                      <div className="poi-coords">
                        Lat: {parseFloat(item.lat).toFixed(4)}<br/>
                        Lng: {parseFloat(item.lng).toFixed(4)}
                      </div>
                    </td>

                    {/* Layers */}
                    <td>
                      {item.layers && item.layers.length > 0 ? (
                        <ul className="poi-list">
                          {item.layers.map((layer, idx) => (
                            <li key={idx} className="poi-tag tag-blue">
                              <Layers size={12} />
                              <a href={layer.link} target="_blank" rel="noreferrer" className="tag-link">
                                {layer.nome}
                              </a>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <span style={{ color: '#cbd5e1', fontStyle: 'italic', fontSize: '0.75rem' }}>Nessun layer</span>
                      )}
                    </td>

                    {/* Oggetti BIM */}
                    <td>
                      {item.bimobj && item.bimobj.length > 0 ? (
                        <ul className="poi-list">
                          {item.bimobj.map((bim, idx) => (
                            <li key={idx} className="poi-tag tag-purple">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 600 }}>
                                <Box size={12} />
                                <span>{bim.bimid}</span>
                              </div>
                              <span style={{ fontSize: '0.65rem', opacity: 0.8, paddingLeft: '1.25rem' }}>{bim.categoria}</span>

                               
                            </li>
                            
                          ))}
                        </ul>
                      ) : (
                        <span style={{ color: '#cbd5e1', fontStyle: 'italic', fontSize: '0.75rem' }}>Nessun oggetto</span>
                      )}
                    </td>

                   

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/*
          <div className="poi-footer">
            <span>Totale record: {data.length}</span>
            <span>Dati aggiornati in tempo reale</span>
          </div>
              */}
        </div>

      </div>
      <Mfooter />
    </div>
  );
};

export default PoiTable;